import { Link } from 'react-router-dom';
import { useCollection } from '@/hooks/useCollection';
import type { GalleryImage } from '@/lib/types';

export default function GalleryPreview() {
  const { rows: images, loading, error, reload } = useCollection<GalleryImage>('gallery_images', 'sort_order', true);
  const published = images.filter((img) => img.is_published !== false);
  const preview = published.slice(0, 8);

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-accent-600 font-label text-sm tracking-widest uppercase font-semibold mb-3">
            Highlights
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight">
            Our Ministry in Action
          </h2>
          <div className="w-12 h-1 bg-accent-500 mt-5 mx-auto" />
        </div>

        {loading ? (
          <p className="text-center text-foreground-400 py-10">
            <i className="ri-loader-4-line animate-spin inline-block" aria-hidden="true" /> Loading gallery...
          </p>
        ) : error ? (
          <div className="text-center py-10">
            <p className="text-red-600 text-sm mb-3">Could not load gallery.</p>
            <button type="button" onClick={reload} className="btn-outline">Retry</button>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
            {preview.map((img, idx) => (
              <Link
                key={img.id}
                to="/highlights"
                className={`group relative overflow-hidden rounded-lg img-zoom ${
                  idx === 0 ? 'sm:col-span-2 sm:row-span-2' : ''
                }`}
                style={{ height: idx === 0 ? '380px' : '180px' }}
                aria-label={`View gallery — ${img.alt}`}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/0 group-hover:bg-white/90 transition-all transform scale-0 group-hover:scale-100">
                    <i className="ri-zoom-in-line text-foreground-800 text-lg" aria-hidden="true" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}

        <div className="text-center mt-10">
          <Link to="/highlights" className="btn-primary">
            <i className="ri-image-line" aria-hidden="true" />
            View Full Gallery
          </Link>
        </div>
      </div>
    </section>
  );
}